export const links = {
  home: {
    to: '/',
    id: 'patientPortal.Navigation.Home',
    description: 'Home',
    defaultMessage: 'Dashboard',
    piwikTitle: 'Home',
  },

  contactus: {
    to: '/contact-us',
    id: 'patientPortal.Navigation.ContactUs',
    description: 'Contact Us',
    defaultMessage: 'Contact Us',
    piwikTitle: 'Contact Us',
  },

  help: {
    to: '/help',
    id: 'patientPortal.Navigation.Help',
    description: 'Help',
    defaultMessage: 'Help',
    piwikTitle: 'Help',
  },

  login: {
    to: '/login',
    id: 'patientPortal.Navigation.LogIn',
    description: 'Login',
    defaultMessage: '{facilityShortName} - {patientPortal}',
    piwikTitle: 'User Login',
  },

  accountSettings: {
    to: '/account-settings',
    id: 'patientPortal.Navigation.AccountSettings',
    description: 'Account Settings',
    defaultMessage: 'Account Settings',
    piwikTitle: 'My Account',
  },

  dataProtection: {
    to: '/personal-data',
    id: 'patientPortal.Navigation.DataProtection',
    description: 'Personal Data & Privacy',
    defaultMessage: 'Personal Data & Privacy',
    piwikTitle: 'Personal Data & Privacy',
  },

  logout: {
    to: '/logout',
    id: 'patientPortal.Navigation.Logout',
    description: 'Log Out',
    defaultMessage: 'Log Out',
    piwikTitle: 'Log Out',
  },

  dashboard: {
    to: '/dashboard',
    id: 'patientPortal.Home.Tabs.Dashboard',
    description: 'Dashboard',
    defaultMessage: 'Dashboard',
    piwikTitle: 'Home',
  },

  healthSummary: {
    to: '/health-summary',
    id: 'patientPortal.Navigation.HealthSummary',
    description: 'Health Information',
    defaultMessage: 'Health Information',
    piwikTitle: 'My CCDA',
  },

  appointments: {
    to: '/appointments',
    id: 'patientPortal.Home.Tabs.Appointments',
    description: 'Appointments',
    defaultMessage: 'Appointments',
    piwikTitle: 'My Appointments',
  },

  treatmentsummary: {
    to: '/treatment-summary',
    id: 'patientPortal.Home.Tabs.TreatmentSummary',
    description: 'Treatment Summary',
    defaultMessage: 'Treatment Summary',
    piwikTitle: 'My Treatments',
  },

  followups: {
    to: '/followup-plan',
    id: 'patientPortal.Home.Tabs.Followups',
    description: 'Follow-Up Plan',
    defaultMessage: 'Follow-Up Plan',
    piwikTitle: 'My Follow-Up Plan',
  },

  education: {
    to: '/education-articles',
    id: 'patientPortal.Home.Tabs.Education',
    description: 'Education',
    defaultMessage: 'Education',
    piwikTitle: 'My Education',
  },

  testresults: {
    to: '/test-results',
    id: 'patientPortal.Home.Tabs.TestResults',
    description: 'Test Results',
    defaultMessage: 'Test Results',
    piwikTitle: 'My Test Results',
  },

  medicalnotes: {
    to: '/medical-notes',
    id: 'patientPortal.Home.Tabs.MedicalNotes',
    description: 'Medical Notes',
    defaultMessage: 'Medical Notes',
    piwikTitle: 'My Medical Notes',
  },

  questionnaires: {
    to: '/questionnaires',
    id: 'patientPortal.Home.Tabs.Questionnaires',
    description: 'Questionnaires',
    defaultMessage: 'Questionnaires',
    piwikTitle: 'My Questionnaires',
  },

  securemessages: {
    to: '/secure-messages',
    id: 'patientPortal.Home.Tabs.SecureMessages',
    description: 'Secure Messages',
    defaultMessage: 'Messages',
    piwikTitle: 'My Messages',
  },

  resetpassword: {
    to: '/reset-password',
    id: 'patientPortal.Navigation.ResetPassword',
    description: 'Reset Password',
    defaultMessage: 'Reset Password',
    piwikTitle: 'Reset Your Password',
  },

  faqs: {
    to: '/faqs',
    id: 'patientPortal.Navigation.Faqs',
    description: 'FAQ',
    defaultMessage: 'FAQ',
    piwikTitle: 'FAQ',
  },

  usefullinks: {
    to: '/useful-links',
    id: 'patientPortal.Navigation.UsefulLinks',
    description: 'Useful Links',
    defaultMessage: 'Useful Links',
    piwikTitle: 'Useful Links',
  },

  downloadableitems: {
    to: '/download-forms',
    id: 'patientPortal.Navigation.DownloadableForms',
    description: 'Download Forms',
    defaultMessage: 'Download Forms',
    piwikTitle: 'Download Forms',
  },

  confirmEmail: {
    to: '/confirm-email',
    id: 'patientPortal.Navigation.ConfirmEmail',
    description: 'Email Confirmation',
    defaultMessage: 'Email Confirmation',
    piwikTitle: 'Email Confirmation',
  },

  provideEmail: {
    to: '/provide-email',
    id: 'patientPortal.Navigation.ProvideEmail',
    description: 'Provide Email',
    defaultMessage: 'Provide Email',
    piwikTitle: 'Provide Email',
  },

  addContact: {
    to: '/add-contact',
    id: 'patientPortal.Navigation.AddContact',
    description: 'Add Contact',
    defaultMessage: 'Add Contact',
    piwikTitle: 'Contact Details',
  },

  editContact: {
    to: '/edit-contact',
    id: 'patientPortal.Navigation.EditContact',
    description: 'Edit Contact',
    defaultMessage: 'Edit Contact',
    piwikTitle: 'Contact Details',
  },

  inviteContactLegal: {
    to: '/invite-auth-statement',
    id: 'patientPortal.Navigation.InviteContact',
    description: 'Invite Contact',
    defaultMessage: 'Invite Contact',
    piwikTitle: 'Authorize My Representative',
  },

  inviteContactPin: {
    to: '/contact-pin',
    id: 'patientPortal.Navigation.InviteContactPin',
    description: 'Invite Contact',
    defaultMessage: 'Invite Contact',
    piwikTitle: 'Authorize My Representative',
  },

  termsOfUse: {
    to: '/termsofuse',
    id: 'patientPortal.Navigation.TermsOfUse',
    description: 'Terms of Use',
    defaultMessage: 'Terms of Use',
    piwikTitle: 'Terms of Use',
  },

  updatePassword: {
    to: '/update-password',
    id: 'patientPortal.Navigation.ChangePassword',
    description: 'Change Your Password',
    defaultMessage: 'Change Your Password',
    piwikTitle: 'Change Your Password',
  },
  signupConfirmIdentity: {
    to: '/sign-up',
    id: 'patientPortal.Navigation.SignUp',
    description: 'Sign Up',
    defaultMessage: 'Sign Up',
    piwikTitle: 'Sign Up',
  },

  signupArConfirmIdentity: {
    to: '/auth-rep-sign-up',
    id: 'patientPortal.Navigation.ArSignUp',
    description: 'Sign Up',
    defaultMessage: 'Sign Up',
    piwikTitle: 'Sign Up',
  },

  signupCreateAccount: {
    to: '/create-account',
    id: 'patientPortal.Navigation.CreateSignUp',
    description: 'Sign Up',
    defaultMessage: 'Sign Up',
    piwikTitle: 'Sign Up',
  },

  siteName: {
    id: 'patientPortal.Site.Name',
    description: 'Patient Portal Site Name',
    defaultMessage: 'Patient Portal',
    piwikTitle: 'Patient Portal',
  },

  ssoLogout: {
    to: '/ssologout',
    id: 'patientPortal.Navigation.SSOlogout',
    description: 'SSO Logout',
    defaultMessage: '{facilityShortName} - {patientPortal}',
    piwikTitle: 'SSO Logout',
  },

  singleSignOnFailed: {
    id: 'patientPortal.Navigation.singleSignOnFailed',
    description: 'Patient Portal Login Failed',
    defaultMessage: 'Login Failed',
    piwikTitle: 'Login Failed',
  },
};
